import { render, staticRenderFns } from "./DistortedButton.vue?vue&type=template&id=3b804b44&"
import script from "./DistortedButton.vue?vue&type=script&lang=js&"
export * from "./DistortedButton.vue?vue&type=script&lang=js&"
import style0 from "./DistortedButton.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports